import i18n from '@/plugins/i18n'

export const formatPrice = (price?: number | null, forceDigits?: boolean) => {
  if (price == null || price === 0) {
    return i18n.global.t('common.forFree') as string
  }

  const priceWithCents = price % 1 != 0 || forceDigits ? price.toFixed(2) : price
  return priceWithCents + ' €'
}
